<script setup lang="ts">
withDefaults(defineProps <{ title?: string }>(), { title: "Aucun résultat" });
</script>

<template>
  <div class="py-8 text-center text-2xl font-medium text-muted">
    {{ title }}
  </div>
</template>
